var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWebProgramming1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_144_249)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2593 31.4565C17.0941 31.4565 16.9277 31.3997 16.7919 31.2841L12.1185 27.3047C11.9573 27.1673 11.8646 26.9666 11.8646 26.7546C11.8646 26.543 11.9577 26.3423 12.1185 26.2049L16.7919 22.2255C17.0953 21.9668 17.5511 22.0035 17.8099 22.307C18.0682 22.6108 18.0319 23.0666 17.7281 23.325L13.7007 26.7546L17.7281 30.1842C18.0319 30.443 18.0682 30.8988 17.8099 31.2022C17.6668 31.3703 17.4637 31.4565 17.2593 31.4565Z",
    fill: "url(#paint0_linear_144_249)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4851 31.4565C26.2808 31.4565 26.0777 31.3703 25.935 31.2022C25.6763 30.8988 25.713 30.443 26.0164 30.1842L30.0437 26.7546L26.0164 23.325C25.713 23.0666 25.6763 22.6108 25.935 22.307C26.1933 22.0035 26.6496 21.9668 26.9526 22.2255L31.626 26.2049C31.7872 26.3423 31.8799 26.543 31.8799 26.7546C31.8799 26.9666 31.7872 27.1673 31.626 27.3047L26.9526 31.2841C26.8168 31.3997 26.6504 31.4565 26.4851 31.4565Z",
    fill: "url(#paint1_linear_144_249)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.218 34.4413C20.1684 34.4413 20.1184 34.436 20.068 34.4255C19.6779 34.3433 19.4281 33.9601 19.5103 33.57L22.4228 19.7414C22.5051 19.3513 22.8879 19.1014 23.2784 19.1836C23.6686 19.2658 23.9184 19.6487 23.8362 20.0392L20.9236 33.8678C20.8519 34.2079 20.5521 34.4413 20.218 34.4413Z",
    fill: "url(#paint2_linear_144_249)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8955 41.9751H4.84905C2.17546 41.9751 0 39.8001 0 37.1261V8.22929C0 5.55571 2.17546 3.38025 4.84905 3.38025H38.8955C41.5691 3.38025 43.7446 5.55571 43.7446 8.22929V37.1261C43.7446 39.8001 41.5691 41.9751 38.8955 41.9751ZM4.84905 4.82465C2.97181 4.82465 1.4444 6.35206 1.4444 8.22929V37.1261C1.4444 39.0033 2.97181 40.5307 4.84905 40.5307H38.8955C40.7728 40.5307 42.3002 39.0033 42.3002 37.1261V8.22929C42.3002 6.35206 40.7728 4.82465 38.8955 4.82465H4.84905Z",
    fill: "url(#paint3_linear_144_249)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0224 14.9448H0.722198C0.323216 14.9448 0 14.6215 0 14.2226C0 13.824 0.323216 13.5004 0.722198 13.5004H43.0224C43.4214 13.5004 43.7446 13.824 43.7446 14.2226C43.7446 14.6215 43.4214 14.9448 43.0224 14.9448Z",
    fill: "url(#paint4_linear_144_249)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3394 11.4889C11.0796 11.4889 10.054 10.4633 10.054 9.20345C10.054 7.94323 11.0796 6.91797 12.3394 6.91797C13.5997 6.91797 14.6249 7.94323 14.6249 9.20345C14.6249 10.4633 13.5997 11.4889 12.3394 11.4889ZM12.3394 8.36237C11.876 8.36237 11.4984 8.73958 11.4984 9.20345C11.4984 9.66732 11.876 10.0445 12.3394 10.0445C12.8033 10.0445 13.1805 9.66732 13.1805 9.20345C13.1805 8.73958 12.8033 8.36237 12.3394 8.36237Z",
    fill: "url(#paint5_linear_144_249)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.31734 11.4667C4.05712 11.4667 3.03186 10.4415 3.03186 9.18124C3.03186 7.92102 4.05712 6.89575 5.31734 6.89575C6.57756 6.89575 7.60283 7.92102 7.60283 9.18124C7.60283 10.4415 6.57756 11.4667 5.31734 11.4667ZM5.31734 8.34015C4.85388 8.34015 4.47626 8.71777 4.47626 9.18124C4.47626 9.6451 4.85388 10.0223 5.31734 10.0223C5.78121 10.0223 6.15843 9.6451 6.15843 9.18124C6.15843 8.71777 5.78121 8.34015 5.31734 8.34015Z",
    fill: "url(#paint6_linear_144_249)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3615 11.5106C18.1017 11.5106 17.0764 10.4854 17.0764 9.22514C17.0764 7.96533 18.1017 6.94006 19.3615 6.94006C20.6217 6.94006 21.647 7.96533 21.647 9.22514C21.647 10.4854 20.6217 11.5106 19.3615 11.5106ZM19.3615 8.38406C18.898 8.38406 18.5208 8.76128 18.5208 9.22514C18.5208 9.68901 18.898 10.0662 19.3615 10.0662C19.8254 10.0662 20.2026 9.68901 20.2026 9.22514C20.2026 8.76128 19.8254 8.38406 19.3615 8.38406Z",
    fill: "url(#paint7_linear_144_249)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_144_249",
    x1: 14.9234,
    y1: 22.0531,
    x2: 14.9234,
    y2: 31.4565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0169F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01C2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_144_249",
    x1: 28.8212,
    y1: 22.0531,
    x2: 28.8212,
    y2: 31.4565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0169F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01C2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_144_249",
    x1: 21.6732,
    y1: 19.168,
    x2: 21.6732,
    y2: 34.4413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0169F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01C2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_144_249",
    x1: 21.8723,
    y1: 3.38025,
    x2: 21.8723,
    y2: 41.9751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0169F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01C2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_144_249",
    x1: 21.8723,
    y1: 13.5004,
    x2: 21.8723,
    y2: 14.9448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0169F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01C2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_144_249",
    x1: 12.3394,
    y1: 6.91797,
    x2: 12.3394,
    y2: 11.4889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0169F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01C2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_144_249",
    x1: 5.31734,
    y1: 6.89575,
    x2: 5.31734,
    y2: 11.4667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0169F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01C2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_144_249",
    x1: 19.3617,
    y1: 6.94006,
    x2: 19.3617,
    y2: 11.5106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0169F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01C2FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_144_249"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.7446,
    height: 43.7446,
    fill: "white",
    transform: "translate(0 0.801025)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebProgramming1);
export default __webpack_public_path__ + "static/media/web-programming 1.7f4824589cdeec84b1d2f8406983bed5.svg";
export { ForwardRef as ReactComponent };